export enum Operation {
    Insert = 1,
    Update = 2,
    Delete = 3,
    Copy = 4,
}
